import { handleActions } from 'redux-actions';
import { actions } from './actions';

const initialState = {
  loadingSpinner: false,
};

const toggleSpinnerReducer = (state = initialState, { payload }) => {
  return {
    ...state,
    loadingSpinner: payload,
  };
};

const reducer = handleActions(
  {
    [actions.toggleSpinner]: toggleSpinnerReducer,
  },
  initialState,
);

export default reducer;
